import { ReactNode } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { PopoverGlobalStyles, StyledPopover } from './styles';
import Button from 'components/new-ui/base/button/Button';

type Props = {
    open: boolean;
    onOpenChange?: (open: boolean) => void;
    buttonEl?: ReactNode;
    children?: ReactNode;
    disabled?: boolean;
};

const PopoverButtonsGroup = ({ open, disabled, onOpenChange, buttonEl, children }: Props) => {
    const defaultButtonEl = (
        <Button disabled={disabled} icon={<PlusOutlined />} type="primary">
            Create New
        </Button>
    );

    return (
        <>
            <PopoverGlobalStyles />
            <StyledPopover
                trigger="click"
                overlayInnerStyle={{
                    borderRadius: 6,
                }}
                placement="bottomRight"
                showArrow={false}
                open={open}
                onOpenChange={onOpenChange}
                content={children}
            >
                {buttonEl ? buttonEl : defaultButtonEl}
            </StyledPopover>
        </>
    );
};

export default PopoverButtonsGroup;
